export const getAnalyticsUrl = (url, substring) => {
  const index = url.indexOf(substring);

  if (index !== -1) {
    return url.substring(index + substring.length);
  }

  return null;
};
